import React from 'react';
import { useInView } from '../useInView';
import { FaIndustry, FaTags, FaShippingFast, FaPalette } from 'react-icons/fa';

const WHY = [
  { icon: <FaIndustry />, title: 'In-House Manufacturing', desc: 'Full control over quality from raw material to finished bag.' },
  { icon: <FaTags />, title: 'Factory Direct Pricing', desc: 'No middlemen — you get the best rate straight from the source.' },
  { icon: <FaShippingFast />, title: 'Fastest Delivery', desc: 'Urgent orders accepted and dispatched same or next day.' },
  { icon: <FaPalette />, title: 'Full Colour Custom Print', desc: 'Your logo, brand colours and design printed on every single piece.' },
];

export default function About() {
  const [ref1, v1] = useInView();
  const [ref2, v2] = useInView();

  return (
    <>
      <style>{`
        .why-item:hover { background: rgba(200,137,58,0.08) !important; transform: translateX(4px); }
        .owner-card:hover { border-color: rgba(200,137,58,0.5) !important; background: rgba(200,137,58,0.06) !important; }
        @media(max-width:900px){ .about-grid { grid-template-columns:1fr!important; } }
        @media(max-width:600px){
          .about-title { font-size:clamp(28px,8vw,44px)!important; }
          .about-desc { font-size:16px !important; line-height:1.6 !important; }
          .why-grid { grid-template-columns:1fr !important; gap:20px !important; }
          .owner-row { flex-direction:column !important; gap:20px !important; }
        }
      `}</style>
      <section id="about" style={s.section}>
        <div style={s.container}>
          <div className="about-grid" style={s.grid}>

            {/* Image side */}
            <div ref={ref1} style={{ ...s.imgSide, opacity: v1 ? 1 : 0, transform: v1 ? 'none' : 'translateX(-40px)', transition: 'all 0.8s ease' }}>
              <div style={s.imgFrame}>
                <img src="https://images.unsplash.com/photo-1542744094-3a31f272c490?w=700&q=85&auto=format" alt="Laxmi Printers Workshop" style={s.img} />
                <div style={s.imgOverlay} />
                {/* Since badge */}
                <div style={s.sinceBadge}>
                  <div style={s.sinceYear}>2009</div>
                  <div style={s.sinceText}>ESTABLISHED</div>
                </div>
              </div>
            </div>

            {/* Text side */}
            <div ref={ref2} style={{ opacity: v2 ? 1 : 0, transform: v2 ? 'none' : 'translateX(40px)', transition: 'all 0.8s ease 0.15s' }}>
              <div style={s.tagLine}>
                <span style={s.tagDash} />
                <span style={s.tag}>WHO WE ARE</span>
              </div>
              <h2 className="about-title" style={s.title}>
                Hyderabad's Premier<br />
                <em style={s.titleItalic}>Bag Printing Experts</em>
              </h2>
              <p className="about-desc" style={s.para}>
                Laxmi Printers is a trusted manufacturer based in Hyderabad, Telangana, specialising
                in eco-friendly and durable packaging solutions for over 15 years. We serve garment &amp; clothing stores, restaurants, jewellery stores,
                boutiques, supermarkets and brands across the world.
              </p>
              <p style={{ ...s.para, marginTop: 12 }}>
                We manufacture <strong style={{ color: '#c8893a' }}>Non-Woven D-Cut Bags, Printed Plastic Carry Bags</strong> and more — all with
                vibrant custom printing at factory-direct prices.
              </p>

              {/* Why list */}
              <div style={s.whyGrid}>
                {WHY.map((w, i) => (
                  <div key={i} className="why-item" style={s.whyItem}>
                    <span style={s.whyIcon}>{w.icon}</span>
                    <div>
                      <div style={s.whyTitle}>{w.title}</div>
                      <div style={s.whyDesc}>{w.desc}</div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Owners */}
              <div style={s.ownersLabel}>MEET THE OWNERS</div>
              <div style={s.ownersRow}>
                {[
                  { init: 'PK', name: 'M Pradeep Kumar', role: 'Founder & Owner', grad: 'linear-gradient(135deg,#c8893a,#e8a84a)' },
                  { init: 'YK', name: 'M Yashwanth Kumar', role: 'Co-Owner & Operations', grad: 'linear-gradient(135deg,#2e7d52,#43a572)' },
                ].map((o) => (
                  <div key={o.name} className="owner-card" style={s.ownerCard}>
                    <div style={{ ...s.ownerAvatar, background: o.grad }}>{o.init}</div>
                    <div>
                      <div style={s.ownerName}>{o.name}</div>
                      <div style={s.ownerRole}>{o.role}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}

const s = {
  section: { background: '#0d0d0d', padding: '120px 24px', position: 'relative' },
  container: { maxWidth: 1280, margin: '0 auto' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 72, alignItems: 'center' },
  imgSide: {},
  imgFrame: { position: 'relative', borderRadius: 20, overflow: 'hidden', boxShadow: '0 40px 100px rgba(0,0,0,0.7)' },
  img: { width: '100%', height: 560, objectFit: 'cover', display: 'block' },
  imgOverlay: {
    position: 'absolute', inset: 0,
    background: 'linear-gradient(to bottom, transparent 50%, rgba(10,10,10,0.6))',
  },
  sinceBadge: {
    position: 'absolute', bottom: 24, left: 24,
    background: 'rgba(10,10,10,0.85)', border: '1px solid rgba(200,137,58,0.4)',
    borderRadius: 14, padding: '14px 20px', backdropFilter: 'blur(12px)',
  },
  sinceYear: {
    fontFamily: "'Cormorant Garamond', serif", fontSize: 36,
    fontWeight: 700, color: '#c8893a', lineHeight: 1,
  },
  sinceText: { fontSize: 10, letterSpacing: 3, color: 'rgba(240,237,230,0.5)', marginTop: 2, fontWeight: 600 },
  ratingCard: {
    position: 'absolute', top: 24, right: -16,
    background: 'rgba(10,10,10,0.92)', border: '1px solid rgba(200,137,58,0.3)',
    borderRadius: 14, padding: '14px 18px', backdropFilter: 'blur(12px)',
    boxShadow: '0 20px 50px rgba(0,0,0,0.5)',
  },
  stars: { fontSize: 16, color: '#c8893a', marginBottom: 4 },
  ratingText: { fontSize: 13, fontWeight: 700, color: '#f0ede6' },
  ratingSubText: { fontSize: 11, color: 'rgba(240,237,230,0.45)', marginTop: 2 },
  tagLine: { display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 },
  tagDash: { width: 32, height: 2, background: '#c8893a', display: 'inline-block' },
  tag: { fontSize: 11, letterSpacing: 3, color: '#c8893a', fontWeight: 700 },
  title: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 'clamp(32px,3.5vw,52px)', fontWeight: 700,
    color: '#f0ede6', lineHeight: 1.15, marginBottom: 20,
  },
  titleItalic: { fontStyle: 'italic', color: '#c8893a' },
  para: { fontSize: 15, color: 'rgba(240,237,230,0.6)', lineHeight: 1.85 },
  whyGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, margin: '28px 0' },
  whyItem: {
    display: 'flex', alignItems: 'flex-start', gap: 12,
    background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)',
    borderRadius: 12, padding: '14px 16px', transition: 'all 0.25s ease',
  },
  whyIcon: { fontSize: 22, flexShrink: 0 },
  whyTitle: { fontSize: 13, fontWeight: 700, color: '#f0ede6', marginBottom: 3 },
  whyDesc: { fontSize: 12, color: 'rgba(240,237,230,0.45)', lineHeight: 1.5 },
  ownersLabel: {
    fontSize: 10, letterSpacing: 3, color: 'rgba(200,137,58,0.6)',
    fontWeight: 700, marginBottom: 12,
  },
  ownersRow: { display: 'flex', gap: 12, flexWrap: 'wrap' },
  ownerCard: {
    display: 'flex', alignItems: 'center', gap: 12, flex: 1, minWidth: 190,
    background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)',
    borderRadius: 12, padding: '14px 18px', transition: 'all 0.25s ease',
  },
  ownerAvatar: {
    width: 44, height: 44, borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'Cormorant Garamond', serif", fontWeight: 700, fontSize: 16,
    color: '#0a0a0a', flexShrink: 0,
  },
  ownerName: { fontSize: 14, fontWeight: 700, color: '#f0ede6' },
  ownerRole: { fontSize: 12, color: '#c8893a', marginTop: 2 },
};
